module.exports = __webpack_public_path__ + "static/media/25_tn.7c5c3ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/25_tn.jpg
// module id = 239
// module chunks = 0